import { Dialog, Transition } from '@headlessui/react';
import People from 'assets/icons/People';
import Button from 'common/components/Button';
import Loader from 'common/components/Loader';
import useTranslation from 'common/hooks/useTranslation';
import { cn } from 'common/utils';
import React, { Fragment } from 'react';

const ConfirmationModal = ({ isOpen, onConfirm, onCancel, isUpdating }) => {
  const { t } = useTranslation('offers\\details');

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as='div'
        className='relative z-50 interview-modal-container'
        onClose={onCancel}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel
                className={cn(
                  'flex flex-col w-full max-w-md transform overflow-hidden',
                  'rounded bg-white p-10 text-left gap-6',
                  'align-middle shadow-xl transition-all relative',
                )}
              >
                <Dialog.Title
                  as='div'
                  className='flex flex-col w-full items-center gap-8'
                >
                  <People size='64px' color='#084D6E' />
                  <h1 className=' text-2xl font-semibold text-dark-charcoal'>
                    {t('modals.interview.title')}
                  </h1>
                </Dialog.Title>
                <Dialog.Description className='text-sm text-cool-grey text-center'>
                  {t('modals.interview.description')}
                </Dialog.Description>
                <div className='w-full flex items-center justify-center gap-2'>
                  <Button
                    variant='secondary'
                    className={'outline-none'}
                    onClick={onCancel}
                  >
                    {t('modals.interview.buttons.cancel')}
                  </Button>
                  <Button variant='primary' onClick={onConfirm}>
                    {t('modals.interview.buttons.continue')}
                  </Button>
                </div>
                {isUpdating && <Loader />}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmationModal;
